import { TextHeaderFragmentFragment } from '../../__generated__/graphql';
import { GradientText, Heading1, Paragraph } from '../../components/Text';
import { ContentBlock } from '../types';

import style from './text-header.module.css';

const fontSize = 48;
const className = style.heading;

const textProps = {
  className,
  fontSize,
} as const;

const TextHeader: ContentBlock<TextHeaderFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.textHeader;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <section
      className={style.section}
      id={contentBlockProps.sectionId ?? undefined}
    >
      {contentBlockProps.withGradientText
        ? (
          <GradientText {...textProps}>
            {contentBlockProps.title}
          </GradientText>
        )
        : (
          <Heading1 {...textProps}>
            {contentBlockProps.title}
          </Heading1>
        )}

      {contentBlockProps.description && (
        <Paragraph className={style.descriptionText}>
          {contentBlockProps.description ?? ''}
        </Paragraph>
      )}
    </section>
  );
};

export default TextHeader;
